import { Routes } from '@angular/router';
import { ErrorViewComponent } from 'src/app/components/misc/error-view/error-view.component';
import { CalendarOverviewComponent } from './components/admin/calendar-overview/calendar-overview.component';
import { CustomerComponent } from './components/admin/customer/customer.component';
import { CustomerEditComponent } from './components/admin/customer/views/customer-edit.component';
import { DashboardComponent } from './components/admin/dashboard/dashboard.component';
import { UsersComponent } from './components/admin/users/users.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { LoginComponent } from './components/auth/login/login.component';
import { NewPasswordComponent } from './components/auth/newpassword/newpassword.component';
import { VerificationComponent } from './components/auth/verification/verification.component';
import { HomeComponent } from './components/templates/home/home.component';
import { authGuard } from './guards/auth.guard';
import { canDeactivateGuard } from './guards/can-deactivate.guard';
import { loginGuard } from './guards/login.guard';
import { roleGuard } from './guards/role.guard';
import { AppLayout } from './layout/components/app.layout';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard]
  },
  {
    path: 'newpassword/:token',
    component: NewPasswordComponent
  },
  {
    path: 'verification',
    component: VerificationComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: '',
    component: AppLayout,
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [authGuard, roleGuard],
        canDeactivate: [canDeactivateGuard]
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [authGuard, roleGuard],
        canDeactivate: [canDeactivateGuard]
      },
      {
        path: 'customers',
        component: CustomerComponent,
        canActivate: [authGuard, roleGuard],
        canDeactivate: [canDeactivateGuard]
      },
      {
        path: 'customers/:id',
        component: CustomerEditComponent,
        canActivate: [authGuard, roleGuard],
        canDeactivate: [canDeactivateGuard]
      },
      // {
      //   path: 'calendar',
      //   component: CalendarOverviewComponent,
      //   canActivate: [authGuard, roleGuard],
      //   canDeactivate: [canDeactivateGuard]
      // },

      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard, roleGuard],
        canDeactivate: [canDeactivateGuard]
      }
    ]
  },
  {
    path: 'error',
    component: ErrorViewComponent
  }
];

// @NgModule({
//   imports: [RouterModule.forRoot(routes)],
//   exports: [RouterModule]
// })
export class AppRoutingModule {}
